import { useEffect, useState } from "react";

import logoFallback from "../../assets/logo.png";
import { Progress } from "./ui/progress";
import { brand } from '@/app/config/tenantConfig'

interface AccessLoadingScreenProps {
  isLoading: boolean;
  onComplete?: () => void;
}

const showStartLogoOnLoading =
  import.meta.env.VITE_SHOW_START_LOGO_ON_LOADING === "true";

export function AccessLoadingScreen({
  isLoading,
  onComplete,
}: AccessLoadingScreenProps) {
  const [progress, setProgress] = useState(8);

  useEffect(() => {
    if (!isLoading) {
      setProgress(100);
      const timeout = setTimeout(() => onComplete?.(), 500);
      return () => clearTimeout(timeout);
    }

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 92) return prev;
        const next = prev + (100 - prev) * 0.12;
        return Math.min(next, 92);
      });
    }, 400);

    return () => clearInterval(interval);
  }, [isLoading, onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex min-h-screen w-full flex-col items-center bg-background px-6 py-10">
      {showStartLogoOnLoading && (
        <img
          src="/main_logo.png"
          alt=""
          className="h-12 w-auto max-w-[200px] object-contain"
        />
      )}
      <div className="flex w-full max-w-sm flex-1 flex-col items-center justify-center gap-2 text-center">
        <img
          src={brand.logoUrl || logoFallback}
          alt="logo"
          className="h-32 w-auto max-w-[240px] object-contain"
        />
        <h1 className="text-3xl font-semibold text-black01">
          Carregando seu acesso...
        </h1>
        <div>
          <p className="text-xl font-medium text-black04">
            isso pode levar alguns instantes
          </p>
          <Progress value={progress} className="mt-8 w-full" />
        </div>
      </div>

      <div className="flex items-end gap-2 pb-2">
        {[0, 0.2, 0.4].map((delay) => (
          <span
            key={delay}
            className="loading-dot h-3 w-3 rounded-full bg-primary"
            style={{ animationDelay: `${delay}s` }}
          />
        ))}
      </div>
    </div>
  );
}
